module.exports = __webpack_public_path__ + "assets/img/0.38effe2d.png";